// @ts-nocheck
import * as React from "react";

const StarFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m7.324 18.923 1.24-5.313-4.123-3.571 5.431-.472L12 4.557l2.127 5.01 5.43.472-4.122 3.57 1.24 5.314L12 16.103l-4.675 2.82Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(StarFill);
